<template>
  <v-app id="inspire">
    <VotacionHeader></VotacionHeader>
    <v-content>
      <v-container fluid class="page-wrapper">
        <v-container fluid class="down-top-padding">
          <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
          <v-row>
            <v-col cols="12" sm="12">
              <BaseCard heading="Elecciones Menú">
                <VotacionLista></VotacionLista>
              </BaseCard>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'VotacionEmpleado',
  components: {
    VotacionLista: () => import('../components/VotacionLista'),
    VotacionHeader: () => import('../components/VotacionHeader')
  },
  data: () => ({
    page: {
      title: 'Comedor'
    },
    breadcrumbs: [
      {
        text: 'Elecciones Menu',
        disabled: true
      }
    ]
  })
};
</script>
